import { useSelector } from 'react-redux';
import { AppState } from './types';

export const useCurrentRouteMatch = (): any => {
    const currentRouteMatch = useSelector<{ app: AppState }>(
        ({ app: { routeMatch } }) => routeMatch
    );
    return currentRouteMatch;
};
